import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { INews } from '../shared/models/news';
import { IApiResponse } from '../../../shared/models/api-response';
import { ToastService } from '../../../shared/services/toast.service';
import { CommitteeNewsService } from '../../committees/shared/services/committee-news.service';


@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrl: './news.component.scss',
    standalone: false
})
export class NewsComponent implements OnInit, OnDestroy {

  loading: boolean = true;
  newsList: INews[] = [];
  subscriptions: Subscription = new Subscription();
  constructor(
    private _CommitteeNewsService: CommitteeNewsService,
    private _toastService: ToastService,
  ) {
  }

  ngOnInit(): void {
    this.getNews();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  getNews() {

    this.subscriptions.add(this._CommitteeNewsService.getNews()
    .subscribe({
      next: (response: IApiResponse<INews[]>) => {
        this.newsList = response.content;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error getting news', error);
        this.loading = false;
      }
    }));
  }

  getNewsUrl(slug: string) {
    return `https://www.standards.org.au/news/${slug}`
  }
}
